import axios from "axios";
import {
  corsBypass,
  REACT_APP_BASE_URL_QALORT,
} from "../constants/enviroments";
import { interceptorHelper } from "./interceptor";
import { handleAxiosError } from "./Axios";

let QAxios = axios.create({
  baseURL: `${
    process.env.NODE_ENV === "development" ? corsBypass : ""
  }${REACT_APP_BASE_URL_QALORT}`,
});

QAxios.interceptors.request.use(
  interceptorHelper.config,
  interceptorHelper.error
);

QAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    return handleAxiosError(error);
  }
);

export function GetCountries() {
  return QAxios.get(`https://restcountries.com/v2/all`);
}

export async function verifyUser(token) {
  return QAxios.get(`v1/users/verify-email/${token}`);
}
